import React from 'react';
import ReactDOM from 'react-dom';
import PropsType from 'prop-types';
import styled from 'styled-components';
import { compose } from 'redux';

import { withGoogleMap } from './createGoogleMap';

/**
 * @example
 *
 * const DefaultMapContainer = styled.div`
 *   height: 320px;
 *   width: 100%;
 * `;
 *
 * const fitBounds = (trip, map) => {
 *   // do something.
 * }
 *
 * const trip = {
 *   // key: value
 * };
 *
 * const markers = [
 *   { location: { lat: 12.343455, lng: 99.323322 }, icon_name: 'airport' },
 *   { location: { lat: 12.112345, lng: 99.876992 }, icon_name: 'Cooking' }
 * ];
 *
 * <GoogleMap
 *   fitBounds={map => fitBounds(trip, map)}
 *   mapContainer={<DefaultMapContainer />}
 *   defaultCenter={{ lat: 13.736717, lng: 100.523186 }}
 *   defaultZoom={5}
 * >
 *   { markers.map((marker, index) => (
 *      <OverlayView
 *        key={`${index}_${marker.icon_name}`}
 *        position={{ lat: marker.location.lat, lng: marker.location.lon }}
 *      >
 *        <CustomIconComponent />
 *      </OverlayView>
 *   ))}
 * </GoogleMap
 */

const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -(height * 1.25),
});

const getLayoutStylesByPosition = (overlayProjection, offset, position) => {
  const point = overlayProjection.fromLatLngToDivPixel(position);
  if (point) {
    const { x, y } = point;
    return {
      left: `${x + offset.x}px`,
      top: `${y + offset.y}px`,
    };
  }
  return {
    left: '-9999px',
    top: '-9999px',
  };
};

const DefaultIcon = styled.div`
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 20px solid blue;
`;

class OverlayView extends React.Component {
  static propTypes = {
    map: PropsType.object,
    position: PropsType.object,
    children: PropsType.element,
  }

  static defaultProps = {
    children: <DefaultIcon/>
  }

  constructor(props) {
    super(props);
    this.overlayView = new google.maps.OverlayView();
    this.overlayView.onAdd = this.onAdd.bind(this);
    this.overlayView.draw = this.draw.bind(this);
    this.overlayView.onRemove = this.onRemove.bind(this);

    this.overlayView.setMap(props.map);
  }

  componentWillUnmount() {
    if (this.overlayView) {
      this.overlayView.setMap(null);
      this.overlayView.onAdd = null;
      this.overlayView.draw = null;
      this.overlayView.onRemove = null;
    }
  }

  onRemove() {
    console.log('ssss');
    this.containerElement.parentNode.removeChild(this.containerElement);
    this.containerElement = null;
  }

  onAdd() {
    this.containerElement = document.createElement('div');
    this.containerElement.style.position = 'absolute';

    ReactDOM.hydrate(React.Children.only(this.props.children), this.containerElement);
  }

  draw() {
    const overlayProjection = this.overlayView.getProjection();
    const offset = {
      x: 0,
      y: 0,
      ...getPixelPositionOffset(this.containerElement.offsetWidth, this.containerElement.offsetHeight),
    };

    const { position = {} } = this.props;
    const layoutStyles = getLayoutStylesByPosition(overlayProjection, offset, new google.maps.LatLng(position));
    Object.assign(this.containerElement.style, layoutStyles);

    const mapPanes = this.overlayView.getPanes();
    mapPanes.overlayLayer.appendChild(this.containerElement);
  }

  render() {
    return null;
  }
}

export default compose(
  withGoogleMap
)(OverlayView);
